const template=`
<widget-status></widget-status>
<generic-highchart
  chart-data="chartData"
  drill="drillDown()"
  ng-hide="widgetIsLoading || serviceError || noDataFromServer || notConfigured"
  ng-if="!showMwVizBarChart && !mwVizBarChartFeature"
>
</generic-highchart>
<mw-chart-one-series-bar
  chart-data="mwOneSeriesBarChartData"
  chart-options="mwOneSeriesBarChartOptions"
  get-api="getMwApi(API)"
  ng-hide="widgetIsLoading"
  ng-if="showMwVizBarChart && mwVizBarChartFeature"
>
</mw-chart-one-series-bar>`;
export default template;
